module.exports = __webpack_public_path__ + "img/store1.d3e16196.png";